module.exports = __webpack_public_path__ + "static/media/cs-screen-3.7346a961.jpg";